export default __webpack_public_path__ + "static/media/Pro Pic small.b0e929c9.jpg";